import React, { forwardRef } from 'react';
import './Contact.css';

const Contact = forwardRef(({ isInView }, ref) => {
  return (
    <section id="contact" className={`Contact ${isInView ? 'is-visible' : ''}`} ref={ref}>
      <h2>Contact Me</h2>
      <form 
        className="Contact-form" 
        action="https://formspree.io/f/mnnklrvz" // <-- IMPORTANT: Replace with your Formspree endpoint
        method="POST"
      >
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input type="text" id="name" name="name" required />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="email" required />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea id="message" name="message" rows="5" required></textarea>
        </div>
        <button type="submit">Send Message</button>
      </form>
    </section>
  );
});

export default Contact;